module.exports = __webpack_public_path__ + "static/media/image-muscle-gain@2x.95e01dc0.png";